import { Directive, ElementRef, Input } from "@angular/core";
import { blinkElement } from "src/app/support/blink";

@Directive({
  selector: "[blink]",
  standalone: false
})
export class BlinkDirective {
  @Input() blink!: boolean;

  constructor(private elementRef: ElementRef) {
    blinkElement(elementRef.nativeElement, ["bg-blue-300"], ["bg-slate-200"]);
  }
}
